import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteRegionLead: (
  fetchContext: FetchContext,
  programRegionLeadId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, programRegionLeadId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/program-region-leads/${programRegionLeadId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete region lead'));
